<div class="inline">

  <ng-container *ngIf="workflowInstance.codeWorkflowStatut != 'end'">
    <yo-button
      [id]="this.uniqueId"
      *ngIf="play"
      [theme]="ButtonThemeEnum.SECONDARY_INNER"
      [disabled]="!workflowSvc.canModifyCurrentStep(workflowInstance)"
      iconClass="fas fa-play"
      tooltip="Passer à une des étapes suivantes">
    </yo-button>

    <yo-button
      [id]="this.uniqueId"
      *ngIf="!play"
      iconPos="right"
      [theme]="ButtonThemeEnum.DEFAULT"
      label="Suivant"
      tooltip="Passer à une des étapes suivantes"
      iconClass="fas fa-angle-right"
      [disabled]="!workflowSvc.canModifyCurrentStep(workflowInstance)">
    </yo-button>

    <dx-popover
      [target]="'#' + this.uniqueId"
      class="menu-content"
      showEvent="click"
      [closeOnOutsideClick]="true">

      <dxo-position
        my="right top"
        at="right bottom">
      </dxo-position>

      <div *dxTemplate="let data of 'content'">
        <ul class="menu-content-list">
          <li *ngFor="let item of nextStepItems">
            <yo-button
              *ngIf="item.visible !== false"
              [label]="item.label"
              [iconClass]="item.icon"
              [disabled]="item.disabled"
              buttonClass="menu-button"
              (onClick)="item.command()">
            </yo-button>
          </li>
        </ul>
      </div>

    </dx-popover>
  </ng-container>
</div>

<p-dialog
  [dismissableMask]="false"
  header="CONFIRMATION DU PASSAGE EN COMMANDE"
  [contentStyle]="{'overflow':'visible'}"
  [responsive]="true"
  [modal]="true"
  [minY]="200"
  [style]="{'width':'800px'}"
  [(visible)]="displayDialogPassageCommande">

  <div class="card">

    <div class="card-body">
      <p>🗣️ ATTENTION, vous ne pourrez plus modifier votre liste de besoins après votre passage en commande.</p>
      <br/>
      <p>
        <i class="fas fa-arrow-right space"></i>{{lbdActifs}} article(s) sélectionné(s) dans votre liste de besoins.
      </p>
      <br/>
      <ng-container *ngIf="listeBesoinEnErreur">
        <p><i class="fas fa-exclamation-triangle danger-color space"></i><b>Votre liste de besoins a {{lbErreurs}}
          article(s) en erreur, veuillez le(s) corriger. </b></p>
        <p style="line-height: 35px;">
          <p-checkbox [(ngModel)]="continueWithErrorsToPassageCommande" binary="true"></p-checkbox>
          Continuer quand même. <em>Les articles en erreur ne seront pas pris en compte.</em>
        </p>

      </ng-container>
    </div>
  </div>

  <ng-template pTemplate="footer">

    <ng-container *ngIf="!listeBesoinEnErreur">
      <yo-button [theme]="ButtonThemeEnum.VALIDATE"
                 iconClass="fas fa-check"
                 (onClick)="goToCommande(workflowInstance)"
                 label="PASSER EN COMMANDE"></yo-button>
    </ng-container>
    <ng-container *ngIf="listeBesoinEnErreur">
      <ng-container *ngIf="continueWithErrorsToPassageCommande">
        <yo-button [theme]="ButtonThemeEnum.VALIDATE"
                   iconClass="fas fa-check"
                   (onClick)="goToCommande(workflowInstance)"
                   label="PASSER EN COMMANDE"></yo-button>
      </ng-container>
      <ng-container *ngIf="!continueWithErrorsToPassageCommande">
        <yo-button [theme]="ButtonThemeEnum.VALIDATE"
                   iconClass="fas fa-check"
                   disabled="true"
                   (onClick)="goToCommande(workflowInstance)"
                   label="PASSER EN COMMANDE"></yo-button>
      </ng-container>


    </ng-container>

    <yo-button [theme]="ButtonThemeEnum.CANCEL_INNER"
               iconClass="fas fa-close"
               (onClick)="displayDialogPassageCommande=false"
               label="ANNULER"></yo-button>
  </ng-template>

</p-dialog>

<yo-livraison-impossible-popup
  [visible]="displayDialogLivraisonImpossible"
  [livraisonImpossibleList]="livraisonImpossibleList"
  (closed)="closeLivraisonImpossibleDialog()">
</yo-livraison-impossible-popup>
